export const suggestedTags: { label: string; color: string }[] = [
  { label: "🐞 bug", color: "volcano" },
  { label: "good first issue", color: "yellow" },
  { label: "🔁 recurring", color: "volcano" },
  { label: "milestone", color: "geekblue" },
];
